module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"address":"Endereço"},"en-US":{"address":"Address"}}')
  delete Component.options._Ctor
}
